export default __webpack_public_path__ + "static/media/shop_main.084795dc.png";